"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isFunction;
function isFunction(value) {
    return value instanceof Function;
}
//# sourceMappingURL=isFunction.js.map